<template>
    <div>
        <h4>แสดงราคา +บาทของสินค้า</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>เลือกประเภทสินค้า</label>
            </div>
            <div class="col-6">
                <select class="form-control" v-model="form.product_type_id">
                    <option
                        v-for="options in optionProductType"
                        :value="options.value">{{ options.text }}</option>
                </select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>ประเภทแพ็คโฟม</label>
            </div>
            <div class="col-6">
                <div style="margin-left: auto;margin-right: auto">
                    <b-form-radio-group v-model="form.pack_type" @input="setValue">
                        <b-form-radio name="promotionOption_type" value="1" :checked=true>แพ็คเล็ก</b-form-radio>
                        <b-form-radio name="promotionOption_type" value="2">แพ็คพิเศษ</b-form-radio>
                        <b-form-radio name="promotionOption_type" value="3">รวมแพ็ค</b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>
        </div>
        <div class="row form-group" v-if="form.product_type_id == 1 || !form.product_type_id">
            <div class="col-4 text-right">
                <label>+บาทโฟม</label>
            </div>
            <div class="col-6">
                <b-form-select :options="add_foam" v-model="form.add_price_foam"></b-form-select>
            </div>
        </div>
        <div class="row form-group" v-if="form.product_type_id !== 1">
            <div class="col-4 text-right">
                <label>+เบ็ดเตล็ด</label>
            </div>
            <div class="col-6">
                <b-form-select :options="add_price_other" v-model="form.add_price_other"></b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-12 text-center">
                <label>เลือกสถานะโปรโมชั่น</label>
            </div>
            <div style="margin-left: auto;margin-right: auto">
                <b-form-radio-group v-model="form.promotionOption_type" @input="setValue">
                    <b-form-radio name="promotionOption_type" value="1" :checked=true>แสดงทั้งหมด</b-form-radio>
                    <b-form-radio name="promotionOption_type" value="2">แสดงบางส่วน</b-form-radio>
                    <b-form-radio name="promotionOption_type" value="3">ไม่แสดงทั้งหมด</b-form-radio>
                </b-form-radio-group>
            </div>
        </div>
        <div class="row form-group" v-if="form.promotionOption_type == 2">
            <div class="col-12 text-center">
                <label>เลือกโปรโมชั่นที่ต้องการให้แสดง</label>
            </div>
            <multiselect
                v-model="form.promotionOption"
                placeholder="เลือกโปรโมชั่น"
                :multiple="true"
                :options="promotionOption"
                :customLabel="customLabel"
                :show-labels="false"
                track-by="id">
            </multiselect>
        </div>
        <div class="col text-center">
            <button
                class="btn btn-success mb-3"
                @click="confirmOrder"
                style="margin-right: 20px">
                <icon name="print"></icon> พิมพ์
            </button>
            <button
                class="btn btn btn-outline-secondary mr-1 mb-3"
                @click="closeModal">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import {mapState} from "vuex";

    export default {
        name: "AddPriceProductModal",
        components:{
            Multiselect,
        },
        data(){
            return {
                add_foam : [
                    {value:'',text:'เลือก +บาทโฟม'},
                    {value:1,text :'+1'},
                    {value:2,text :'+2'},
                    {value:3,text :'+3'},
                    {value:4,text :'+4'},
                    {value:5,text :'+5'},
                ],
                add_price_other : [
                    {value:'',text:'เลือก +เบ็ดเตล็ด'},
                    {value:1,text :'+10'},
                    {value:2,text :'+20'},
                    {value:3,text :'+30'},
                    {value:4,text :'+40'},
                    {value:5,text :'+50'},
                ],
                form : {
                    add_price_foam : '',
                    add_price_other : '',
                    product_type_id : "",
                    promotionOption : [],
                    promotionOption_type : 1,
                    pack_type : 3,
                },
                promotionOption : [],
            }
        },
        created() {
            this.getPromotionOption();
        },
        computed:{
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                optionProductType : state =>{
                    return [
                        {
                            value: "",
                            text: "หมวดหมู่สินค้า"
                        },
                        ...state.ProductType.data.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
            })
        },
        methods:{
            setValue(value){
                if(value != 2){
                    this.form.promotionOption = [];
                }
            },
            confirmOrder(){
                this.$emit('submit',this.form);
            },
            closeModal(){
                this.$emit('submit',false);
            },
            getPromotionOption(){
                this.$store.dispatch("Products/getPromotionOption").then(res=>{
                    this.promotionOption = res;
                })
            },
            customLabel(option){
                return `${option.name_promotion}`
            },
        }
    }
</script>

<style scoped>

</style>
